import React, { useRef } from "react";
import { useLocation } from "@reach/router";
import { ThemeProvider, css } from "styled-components";
import Swiper from "react-id-swiper";
import { SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";

const WrapperSubBanner = css`
  overflow: hidden;

  img {
    box-shadow: 0px 5px 10px #ffffff, 1px 5px 7px -1px #00000080;
  }

  .customized-swiper-pagination {
    bottom: 0 !important;
    margin: 10px auto;
    max-width: fit-content;
    width: fit-content;
    position: relative;
    background: #e8e8e0 0% 0% no-repeat padding-box;
    box-shadow: -5px -5px 10px #ffffff, 4px 4px 10px #d1d1d0;
    border-radius: 10px;
    opacity: 1;

    @media screen and (max-width: 1200px) {
      transform: scale(0.7);
    }
  }

  .swiper-pagination-bullet {
    background: ${(props) => props.theme.color};
  }

  .arrow {
    border: solid ${(props) => props.theme.color};
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 10px;
  }

  .left {
    transform: rotate(135deg) translate(0px, -5px);
    -webkit-transform: rotate(135deg) translate(0px, -5px);
  }

  .right {
    transform: rotate(-45deg) translate(-5px, 0px);
    -webkit-transform: rotate(-45deg) translate(-5px, 0px);
  }

  .buttonPre {
    position: absolute;
    transform: translate(40px, -180px);
    left: 0;
    width: 60px;
    height: 60px;
    background: #e8e8e0 0% 0% no-repeat padding-box;
    border-radius: 50%;
    box-shadow: -5px -5px 10px #ffffff, 4px 4px 10px #d1d1d0;
    opacity: 1;
    z-index: 999;
  }

  .buttonNext {
    position: absolute;
    transform: translate(-40px, -180px);
    right: 0;
    width: 60px;
    height: 60px;
    background: #e8e8e0 0% 0% no-repeat padding-box;
    border-radius: 50%;
    box-shadow: -5px -5px 10px #ffffff, 4px 4px 10px #d1d1d0;
    opacity: 1;
    z-index: 999;
  }

  @media screen and (max-width: 1200px) {
    .buttonPre {
      transform: translate(135px, -130px) scale(0.7);
    }

    .buttonNext {
      transform: translate(-135px, -130px) scale(0.7);
    }
  }

  @media screen and (max-width: 1180px) {
    .buttonPre {
      transform: translate(100px, -130px) scale(0.7);
    }

    .buttonNext {
      transform: translate(-100px, -130px) scale(0.7);
    }
  }

  @media screen and (max-width: 1020px) {
    .buttonPre {
      transform: translate(70px, -130px) scale(0.6);
    }

    .buttonNext {
      transform: translate(-70px, -130px) scale(0.6);
    }
  }

  @media screen and (max-width: 950px) {
    .buttonPre {
      transform: translate(30px, -130px) scale(0.6);
    }

    .buttonNext {
      transform: translate(-30px, -130px) scale(0.6);
    }
  }

  @media screen and (max-width: 800px) {
    .buttonPre,
    .buttonNext {
      display: none;
    }
  }
`;

const SubBannerComponent = ({ subBannerList, pageName }) => {
  const ref = useRef(null);
  const goNext = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper.slidePrev();
    }
  };

  const params = {
    modules: [Navigation, Pagination, Autoplay],
    pagination: {
      clickable: true,
      el: ".swiper-pagination.customized-swiper-pagination",
    },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    spaceBetween: 10,
    slidesPerView: 3,
  };

  const colorTheme = {
    live22: {
      color: "#0396ff",
    },
    slotxo: {
      color: "#E40203",
    },
    pgslot: {
      color: "#28BC7B",
    },
    joker: {
      color: "#FF12A4",
    },
    ambslot: {
      color: "#FFB503",
    },
  };
  return (
    <ThemeProvider theme={colorTheme[pageName]}>
      <div css={WrapperSubBanner} className="w-full mx-auto mt-5 p-1 container">
        <Swiper {...params} ref={ref} className="mySwiper">
          {subBannerList.map((items, idx) => (
            <SwiperSlide key={idx}>
              <img src={items.url} alt="" />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-pagination"></div>
        <button className="buttonPre sm:hidden" onClick={goPrev}>
          <i className="arrow left"></i>
        </button>
        <button className="buttonNext sm:hidden" onClick={goNext}>
          <i className="arrow right"></i>
        </button>
      </div>
    </ThemeProvider>
  );
};

export default SubBannerComponent;
